import React, { useState } from "react";
import { auth } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useNavigate } from "react-router-dom"; // <— προσθήκη!

const LoginRegister = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate(); // <— hook για πλοήγηση

  const HandleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (isRegister) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }

      // ✅ μόλις ολοκληρωθεί το login ή register
      if (onLogin) onLogin(); // προαιρετικά, αν το χρησιμοποιείς κάπου
      navigate("/user/stuff/dashboard"); // ← αυτό κάνει το redirect!
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-container text-center text-white bg-dark p-5 rounded">
      <h2>{isRegister ? "Create Account" : "Login"}</h2>
      <form onSubmit={HandleSubmit}>
        <input
          type="email"
          placeholder="Email"
          className="form-control my-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          className="form-control my-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="text-danger">{error}</p>}
        <button type="submit" className="btn btn-secondary w-100 mt-3">
          {isRegister ? "Register" : "Login"}
        </button>
      </form>

      <button
        className="btn btn-link text-light mt-3"
        onClick={() => setIsRegister(!isRegister)}
      >
        {isRegister
          ? "Already have an account? Login"
          : "Create an account"}
      </button>
    </div>
  );
};

export default LoginRegister;
